import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsIndicatorCardsWithModals = _resolveComponent("DashboardsIndicatorCardsWithModals")!

  return (_openBlock(), _createBlock(_component_DashboardsIndicatorCardsWithModals, {
    cardsConfig: _ctx.cardsConfig,
    filter: _ctx.filter,
    modalsConfig: _ctx.modalsConfig,
    wrapInSection: false
  }, null, 8, ["cardsConfig", "filter", "modalsConfig"]))
}